/* unplugin-vue-components disabled */import script from "./PracticeDialog.vue?vue&type=script&setup=true&name=practiceDialog&lang=js"
export * from "./PracticeDialog.vue?vue&type=script&setup=true&name=practiceDialog&lang=js"

import "./PracticeDialog.vue?vue&type=style&index=0&id=4c2196d6&lang=scss&scoped=true"
import "./PracticeDialog.vue?vue&type=style&index=1&id=4c2196d6&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c2196d6"]])

export default __exports__